import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

export const OverlayTreatment = styled.div`
  align-items: ${({ alignChild }) => position(alignChild)};
  animation: ${({ animation }) => animation};
  animation-fill-mode: forwards;
  background: ${({ background }) => background};
  bottom: 0;
  display: flex;
  justify-content: ${({ justifyChild }) => position(justifyChild)};
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
`;

export default class Overlay extends Component {
  static propTypes = {
    animation: PropTypes.string,
    children: PropTypes.any,
    background: PropTypes.string,
    justifyChild: PropTypes.oneOf(['left', 'right', 'center']),
    onClick: PropTypes.func,
    alignChild: PropTypes.oneOf(['top', 'bottom', 'center']),
  };

  static defaultProps = {
    alignChild: 'center',
    justifyChild: 'center',
    background: 'rgba(51, 51, 51, .4)',
  };

  render() {
    const {
      animation,
      background,
      children,
      justifyChild,
      onClick,
      alignChild,
    } = this.props;

    return (
      <OverlayTreatment
        animation={animation}
        background={background}
        onClick={onClick}
        justifyChild={justifyChild}
        alignChild={alignChild}
      >
        {children}
      </OverlayTreatment>
    );
  }
}

function position(pos) {
  switch (pos) {
    case 'top':
    case 'left':
      return 'flex-start';
    case 'bottom':
    case 'right':
      return 'flex-end';
    default:
      return 'center';
  }
}
